
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block;
}

.link {
  position: relative;
  display: flex;
  height: 100%;
  min-height: 556px;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

@media (min-width: 1280px) {

  .link {
    min-height: 400px;
  }
}

@media (min-width: 1440px) {

  .link {
    min-height: 556px;
  }
}

.text-wrapper {
  position: relative;
  display: grid;
  min-height: 100%;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  justify-content: center;
  padding-left: 2rem;
  padding-right: 2rem;
  color: var(--neutral-white);
}

@media (min-width: 768px) {

  .text-wrapper {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .text-wrapper {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.text-wrapper{
  z-index:10;
}

.text-wrapper.new-design {
  position: relative;
}

.text-wrapper.new-design {
  display: grid;
}

.text-wrapper.new-design {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.text-wrapper.new-design {
  overflow: hidden;
}

.text-wrapper.new-design {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 768px) {

  .text-wrapper.new-design {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .text-wrapper.new-design {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.text-wrapper.new-design{
    grid-template-rows:auto minmax(0, 1fr);
  }

.text-wrapper.centered {
  position: relative;
}

.text-wrapper.centered {
  display: grid;
}

.text-wrapper.centered {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.text-wrapper.centered {
  justify-items: center;
}

.text-wrapper.centered {
  overflow: hidden;
}

.text-wrapper.centered {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 768px) {

  .text-wrapper.centered {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .text-wrapper.centered {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.text-wrapper.left-aligned {
  position: relative;
}

.text-wrapper.left-aligned {
  display: grid;
}

.text-wrapper.left-aligned {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.text-wrapper.left-aligned {
  justify-items: start;
}

.text-wrapper.left-aligned {
  overflow: hidden;
}

.text-wrapper.left-aligned {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 768px) {

  .text-wrapper.left-aligned {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .text-wrapper.left-aligned {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.text-wrapper.wide-title {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-items: center;
  overflow: hidden;
  padding-left: 4rem;
  padding-right: 4rem;
  text-align: right;
  min-height:350px;
}

.gray-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10;
  height: 100%;
  width: 100%;
  background-color:rgba(0, 0, 0, 0.5);
}

picture img {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  object-fit: cover;
  height:100% !important;
}

.banner-heading {
  grid-column-start: 1;
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 768px) {

  .banner-heading {
    grid-column-start: 3;
  }

  .banner-heading {
    width: 100%;
  }

  .banner-heading {
    padding-left: 0px;
    padding-right: 0px;
  }
}

:host([centered]) .banner-heading, :host([centered='true']) .banner-heading {
  grid-column-start: 1;
  justify-content: center;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
}

@media (min-width: 768px) {

  :host([centered]) .banner-heading, :host([centered='true']) .banner-heading {
    grid-column-start: 2;
  }

  :host([centered]) .banner-heading, :host([centered='true']) .banner-heading {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.paragraph, .metrics {
  grid-column-start: 1;
  display: none;
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 768px) {

  .paragraph, .metrics {
    grid-column-start: 3;
  }

  .paragraph, .metrics {
    display: block;
  }

  .paragraph, .metrics {
    width: 100%;
  }

  .paragraph, .metrics {
    padding-left: 0px;
    padding-right: 0px;
  }
}

:host([centered]) .paragraph, :host([centered='true']) .paragraph, :host([centered]) .metrics, :host([centered='true']) .metrics, :host([centered]) .eyebrow, :host([centered='true']) .eyebrow {
  grid-column-start: 1;
  justify-content: center;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
}

@media (min-width: 768px) {

  :host([centered]) .paragraph, :host([centered='true']) .paragraph, :host([centered]) .metrics, :host([centered='true']) .metrics, :host([centered]) .eyebrow, :host([centered='true']) .eyebrow {
    grid-column-start: 2;
  }

  :host([centered]) .paragraph, :host([centered='true']) .paragraph, :host([centered]) .metrics, :host([centered='true']) .metrics, :host([centered]) .eyebrow, :host([centered='true']) .eyebrow {
    padding-left: 0px;
    padding-right: 0px;
  }
}

:host([centered]) .metrics .container {
  justify-content: center;
}

.cta {
  grid-column-start: 1;
  margin-top: 0.75rem;
  margin-bottom: 1.25rem;
  display: block;
  width: 100%;
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 768px) {

  .cta {
    grid-column-start: 3;
  }

  .cta {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 1024px) {

  .cta {
    white-space: nowrap;
  }
}

.text-wrapper.wide-title.cta {
  display: flex;
  justify-content: center;
}

:host([centered]) .cta, :host([centered='true']) .cta {
  grid-column-start: 1;
  margin-top: 2rem;
  justify-content: center;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
}

@media (min-width: 768px) {

  :host([centered]) .cta, :host([centered='true']) .cta {
    grid-column-start: 2;
  }

  :host([centered]) .cta, :host([centered='true']) .cta {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 1280px) {

  :host([centered]) .cta, :host([centered='true']) .cta {
    margin-top: 1rem;
  }
}

@media (min-width: 1440px) {

  :host([centered]) .cta, :host([centered='true']) .cta {
    margin-top: 2rem;
  }
}

:host([centered]) .wide-title .cta, :host([centered='true']) .wide-title .cta {
  display: flex;
  justify-content: center;
  padding-left: 0px;
  padding-right: 0px;
}

.new-design .banner-heading, .new-design .eyebrow {
  color: var(--blue-responsible-main);
}

.new-design .paragraph {
  color: var(--outline-black);
}

.new-design .banner-heading, .new-design .paragraph, .new-design .metrics, .new-design .eyebrow, .new-design .cta {
  grid-column-start: 1;
}

.new-design .banner-heading, .new-design .paragraph, .new-design .metrics, .new-design .eyebrow, .new-design .cta {
  text-align: center;
}

@media (min-width: 768px) {

  .new-design .banner-heading, .new-design .paragraph, .new-design .metrics, .new-design .eyebrow, .new-design .cta {
    grid-column-start: 5;
  }
}

@media (min-width: 768px) {

  .new-design .banner-heading, .new-design .paragraph, .new-design .metrics, .new-design .eyebrow, .new-design .cta {
    grid-column-end: 11;
  }
}

@media (min-width: 768px) {

  .new-design .banner-heading, .new-design .paragraph, .new-design .metrics, .new-design .eyebrow, .new-design .cta {
    text-align: right;
  }
}

@media (min-width: 1024px) {

  .new-design .banner-heading, .new-design .paragraph, .new-design .metrics, .new-design .eyebrow, .new-design .cta {
    grid-column-start: 7;
  }
}

.new-design.image-gradient-styles {
  min-height: 410px;
}

@media (min-width: 1280px) {

  .new-design.image-gradient-styles {
    min-height: 310px;
  }
}

@media (min-width: 1440px) {

  .new-design.image-gradient-styles {
    min-height: 410px;
  }
}

.new-design.image-gradient-styles .banner-heading {
  margin-top: 20rem;
}

.new-design.image-gradient-styles .banner-heading {
  color: var(--blue-responsible-main);
}

@media (min-width: 768px) {

  .new-design.image-gradient-styles .banner-heading {
    margin-top: 3rem;
  }
}

@media (min-width: 1280px) {

  .new-design.image-gradient-styles .banner-heading {
    margin-top: 1.5rem;
  }
}

@media (min-width: 1440px) {

  .new-design.image-gradient-styles .banner-heading {
    margin-top: 3rem;
  }
}

.new-design.image-gradient-styles .paragraph {
  color: var(--outline-black);
}

.new-design.image-gradient-styles .banner-heading, .new-design.image-gradient-styles .paragraph, .new-design.image-gradient-styles .metrics, .new-design.image-gradient-styles .eyebrow, .new-design.image-gradient-styles .cta {
  grid-column-start: 1;
}

.new-design.image-gradient-styles .banner-heading, .new-design.image-gradient-styles .paragraph, .new-design.image-gradient-styles .metrics, .new-design.image-gradient-styles .eyebrow, .new-design.image-gradient-styles .cta {
  text-align: center;
}

@media (min-width: 768px) {

  .new-design.image-gradient-styles .banner-heading, .new-design.image-gradient-styles .paragraph, .new-design.image-gradient-styles .metrics, .new-design.image-gradient-styles .eyebrow, .new-design.image-gradient-styles .cta {
    grid-column-start: 5;
  }
}

@media (min-width: 768px) {

  .new-design.image-gradient-styles .banner-heading, .new-design.image-gradient-styles .paragraph, .new-design.image-gradient-styles .metrics, .new-design.image-gradient-styles .eyebrow, .new-design.image-gradient-styles .cta {
    grid-column-end: 11;
  }
}

@media (min-width: 768px) {

  .new-design.image-gradient-styles .banner-heading, .new-design.image-gradient-styles .paragraph, .new-design.image-gradient-styles .metrics, .new-design.image-gradient-styles .eyebrow, .new-design.image-gradient-styles .cta {
    text-align: right;
  }
}

@media (min-width: 1024px) {

  .new-design.image-gradient-styles .banner-heading, .new-design.image-gradient-styles .paragraph, .new-design.image-gradient-styles .metrics, .new-design.image-gradient-styles .eyebrow, .new-design.image-gradient-styles .cta {
    grid-column-start: 7;
  }
}

.new-design.image-gradient-styles .paragraph, .new-design.image-gradient-styles .metrics, .new-design.image-gradient-styles .eyebrow, .new-design.image-gradient-styles .cta {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.new-design.image-gradient-styles .cta {
  margin-bottom: 0px;
}

@media (min-width: 768px) {

  .new-design.image-gradient-styles .cta {
    margin-bottom: 3rem;
  }
}

@media (min-width: 1280px) {

  .new-design.image-gradient-styles .cta {
    margin-bottom: 1.5rem;
  }
}

@media (min-width: 1440px) {

  .new-design.image-gradient-styles .cta {
    margin-top: 3rem;
  }
}

.new-design.image-gradient-styles picture img {
  max-height: 24rem;
}

.new-design.image-gradient-styles picture img {
  object-position: center;
}

@media (min-width: 768px) {

  .new-design.image-gradient-styles picture img {
    max-height: 100%;
  }
}

:host([centered]) .banner-heading, :host([centered]) .paragraph, :host([centered]) .metrics, :host([centered]) .eyebrow, :host([centered]) .cta, :host([centered='true']) .banner-heading, :host([centered='true']) .paragraph, :host([centered='true']) .metrics, :host([centered='true']) .eyebrow, :host([centered='true']) .cta {
  grid-column-end: 2;
}

:host([centered]) .banner-heading, :host([centered]) .paragraph, :host([centered]) .metrics, :host([centered]) .eyebrow, :host([centered]) .cta, :host([centered='true']) .banner-heading, :host([centered='true']) .paragraph, :host([centered='true']) .metrics, :host([centered='true']) .eyebrow, :host([centered='true']) .cta {
  display: flex;
}

:host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
  grid-column-start: 1;
  margin-top: 7rem;
  justify-content: flex-start;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: left;
}

@media (min-width: 768px) {

  :host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
    grid-column-start: 2;
  }

  :host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
    grid-column-end: 8;
  }

  :host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 1024px) {

  :host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
    grid-column-end: 7;
  }
}

@media (min-width: 1280px) {

  :host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
    margin-top: 3.5rem;
  }
}

@media (min-width: 1440px) {

  :host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
    margin-top: 7rem;
  }
}

:host([left-aligned]) .paragraph, :host([left-aligned='true']) .paragraph, :host([left-aligned]) .metrics, :host([left-aligned='true']) .metrics, :host([left-aligned]) .eyebrow, :host([left-aligned='true']) .eyebrow {
  grid-column-start: 1;
  justify-content: flex-start;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: left;
}

@media (min-width: 768px) {

  :host([left-aligned]) .paragraph, :host([left-aligned='true']) .paragraph, :host([left-aligned]) .metrics, :host([left-aligned='true']) .metrics, :host([left-aligned]) .eyebrow, :host([left-aligned='true']) .eyebrow {
    grid-column-start: 2;
  }

  :host([left-aligned]) .paragraph, :host([left-aligned='true']) .paragraph, :host([left-aligned]) .metrics, :host([left-aligned='true']) .metrics, :host([left-aligned]) .eyebrow, :host([left-aligned='true']) .eyebrow {
    grid-column-end: 8;
  }

  :host([left-aligned]) .paragraph, :host([left-aligned='true']) .paragraph, :host([left-aligned]) .metrics, :host([left-aligned='true']) .metrics, :host([left-aligned]) .eyebrow, :host([left-aligned='true']) .eyebrow {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 1024px) {

  :host([left-aligned]) .paragraph, :host([left-aligned='true']) .paragraph, :host([left-aligned]) .metrics, :host([left-aligned='true']) .metrics, :host([left-aligned]) .eyebrow, :host([left-aligned='true']) .eyebrow {
    grid-column-end: 7;
  }
}

:host([left-aligned]) .metrics .container, :host([left-aligned='true']) .metrics .container {
  justify-content: flex-start;
}

:host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
  grid-column-start: 1;
  margin-top: 2rem;
  justify-content: flex-start;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: left;
}

@media (min-width: 768px) {

  :host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
    grid-column-start: 2;
  }

  :host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
    grid-column-end: 8;
  }

  :host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 1024px) {

  :host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
    grid-column-end: 7;
  }
}

@media (min-width: 1280px) {

  :host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
    margin-top: 1rem;
  }
}

@media (min-width: 1440px) {

  :host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
    margin-top: 2rem;
  }
}

:host([left-aligned]) .wide-title .cta, :host([left-aligned='true']) .wide-title .cta {
  display: flex;
  justify-content: flex-start;
  padding-left: 0px;
  padding-right: 0px;
}

.title-base-3 {
  font-size: var(--fs-4xl);
  line-height: var(--lh-4xl);
  font-weight: var(--fw-black);
}

@media (min-width: 768px) {

  .title-base-3 {
    font-size: var(--fs-5xl);
    line-height: var(--lh-5xl);
  }
}

@media (min-width: 1280px) {

  .title-base-3 {
    font-size: var(--fs-6xl);
    line-height: var(--lh-6xl);
  }
}

.title-base-4 {
  font-size: var(--fs-4xl);
  line-height: var(--lh-4xl);
  font-weight: var(--fw-black);
}

@media (min-width: 768px) {

  .title-base-4 {
    font-size: var(--fs-5xl);
    line-height: var(--lh-5xl);
  }
}

@media (min-width: 1280px) {

  .title-base-4 {
    font-size: var(--fs-7xl);
    line-height: var(--lh-7xl);
  }
}

@media (min-width: 2180px) {

  .title-base-4 {
    font-size: var(--fs-8xl);
    line-height: var(--lh-8xl);
  }
}

:host .header-sizes .text-wrapper {
  width: 100%;
}

:host .header-sizes .banner-heading {
  margin-bottom: 1rem;
}

:host .header-sizes .banner-heading {
  margin-top: 0px;
}

:host .header-sizes .paragraph {
  display: none;
}

:host .header-sizes .paragraph {
  justify-content: flex-end;
}

@media (min-width: 640px) {

  :host .header-sizes .paragraph {
    display: flex;
  }
}

:host .header-sizes.link {
  height: 100%;
}

:host .header-sizes.link {
  min-height: 400px;
}

:host .header-sizes.link {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

@media (min-width: 768px) {

  :host .header-sizes.link {
    min-height: 556px;
  }
}

@media (min-width: 1280px) {

  :host .header-sizes.link {
    min-height: 400px;
  }
}

@media (min-width: 1440px) {

  :host .header-sizes.link {
    min-height: 556px;
  }
}

:host .header-sizes .banner-heading, :host .header-sizes .paragraph, :host .header-sizes .metrics, :host .header-sizes .eyebrow, :host .header-sizes .cta {
  grid-column-end: 12;
}

:host([centered]) .header-sizes .banner-heading, :host([centered]) .header-sizes .paragraph, :host([centered]) .header-sizes .metrics, :host([centered]) .header-sizes .eyebrow, :host([centered]) .header-sizes .cta, :host([centered='true']) .header-sizes .banner-heading, :host([centered='true']) .header-sizes .paragraph, :host([centered='true']) .header-sizes .metrics, :host([centered='true']) .header-sizes .eyebrow, :host([centered='true']) .header-sizes .cta {
  grid-column-start: 2;
}

:host([centered]) .header-sizes .banner-heading, :host([centered]) .header-sizes .paragraph, :host([centered]) .header-sizes .metrics, :host([centered]) .header-sizes .eyebrow, :host([centered]) .header-sizes .cta, :host([centered='true']) .header-sizes .banner-heading, :host([centered='true']) .header-sizes .paragraph, :host([centered='true']) .header-sizes .metrics, :host([centered='true']) .header-sizes .eyebrow, :host([centered='true']) .header-sizes .cta {
  grid-column-end: 3;
}

:host([centered]) .header-sizes .paragraph, :host([centered='true']) .header-sizes .paragraph {
  justify-content: center;
}

:host([left-aligned]) .header-sizes .banner-heading, :host([left-aligned]) .header-sizes .paragraph, :host([left-aligned]) .header-sizes .metrics, :host([left-aligned]) .header-sizes .eyebrow, :host([left-aligned]) .header-sizes .cta, :host([left-aligned='true']) .header-sizes .banner-heading, :host([left-aligned='true']) .header-sizes .paragraph, :host([left-aligned='true']) .header-sizes .metrics, :host([left-aligned='true']) .header-sizes .eyebrow, :host([left-aligned='true']) .header-sizes .cta {
  grid-column-end: 7;
}

:host([left-aligned]) .header-sizes .paragraph, :host([left-aligned='true']) .header-sizes .paragraph {
  justify-content: flex-start;
}

:host([full-width]) .text-wrapper, :host([full-width][left-aligned]) .text-wrapper {
  width: 100%;
}

@media (min-width: 768px) {

  :host([full-width]) .text-wrapper.centered, :host([full-width][left-aligned]) .text-wrapper.centered {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

:host([full-width]) .banner-heading, :host([full-width]) .paragraph, :host([full-width]) .metrics, :host([full-width]) .eyebrow, :host([full-width][left-aligned]) .banner-heading, :host([full-width][left-aligned]) .paragraph, :host([full-width][left-aligned]) .metrics, :host([full-width][left-aligned]) .eyebrow {
  grid-column-start: 2;
}

:host([full-width]) .banner-heading, :host([full-width]) .paragraph, :host([full-width]) .metrics, :host([full-width]) .eyebrow, :host([full-width][left-aligned]) .banner-heading, :host([full-width][left-aligned]) .paragraph, :host([full-width][left-aligned]) .metrics, :host([full-width][left-aligned]) .eyebrow {
  grid-column-end: 12;
}

:host([full-width]) .cta, :host([full-width][left-aligned]) .cta {
  grid-column-end: 12;
}

:host([full-width][centered]) .banner-heading, :host([full-width][centered]) .paragraph, :host([full-width][centered]) .metrics, :host([full-width][centered]) .eyebrow {
  grid-column-start: 2;
}

:host([full-width][centered]) .banner-heading, :host([full-width][centered]) .paragraph, :host([full-width][centered]) .metrics, :host([full-width][centered]) .eyebrow {
  grid-column-end: 12;
}

:host([full-width][centered]) .cta {
  grid-column-end: 12;
}

.text-cyan .banner-heading, .text-cyan .paragraph, .text-cyan .metrics, .text-cyan .eyebrow {
  color: var(--cyan-near-main);
}

.text-white .banner-heading, .text-white .paragraph, .text-white .metrics, .text-white .eyebrow {
  color: var(--neutral-white);
}

@media (max-width: 991px){
  .cta-banner-jap{
    word-break:keep-all;
    font-size:1.25rem;
  }
}

.metrics .container {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.metrics .container {
  display: flex;
}

.metrics .container {
  flex-wrap: wrap;
}

.metrics .container {
  justify-content: flex-end;
}

.metrics .container {
  gap: 1.5rem;
}

.metrics .metric {
  width: -moz-min-content;
  width: min-content;
}

.metrics .metric {
  min-width: 8.8rem;
}

.metrics .metric {
  text-align: center;
}

.metrics .metric {
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
}

.metrics .metric p {
  margin: 0px;
}

.metrics .metric .metric-value span {
  font-size: var(--fs-6xl);
  line-height: var(--lh-6xl);
}`;